/* eslint-disable */

/**
 * @note this file is auto-generated from running "npm run import-zebralist".
 * Please do not manually write to this file.
 */
export const ZEBRALIST = {
	"DYNAMIC": [
		"/member/.*",
		"/blog/.*"
	],
	"STATIC": [
		"/nyt-spelling-bee/",
		"/random-word-generator/",
		"/crosswords/",
		"/contexto/",
		"/anagram-solver/",
		"/jumble-solver/",
		"/ending-in-ing/"
	]
};